import React from 'react';
import { ArrowUpRight, Instagram, Linkedin, Sparkles } from 'lucide-react';

export const LinktreeLanding: React.FC = () => {
  return (
    <div className="linktree-sans relative min-h-screen overflow-hidden bg-[#f6f1e8] text-[#1c1b17]">
      <div className="pointer-events-none absolute inset-0">
        <div
          className="absolute -top-28 -right-24 h-72 w-72 rounded-full bg-emerald-300/50 blur-3xl linktree-float"
          style={{ animationDelay: '0s', animationDuration: '14s' }}
        />
        <div
          className="absolute top-24 -left-20 h-64 w-64 rounded-full bg-amber-300/40 blur-3xl linktree-float"
          style={{ animationDelay: '1.2s', animationDuration: '16s' }}
        />
        <div
          className="absolute bottom-0 right-10 h-80 w-80 rounded-full bg-lime-200/40 blur-[110px] linktree-float"
          style={{ animationDelay: '2.4s', animationDuration: '18s' }}
        />
        <div className="absolute inset-0 opacity-40 linktree-grid" />
      </div>

      <div className="relative z-10 mx-auto flex min-h-screen max-w-2xl flex-col justify-center px-6 py-16 sm:py-24">
        <div className="linktree-fade rounded-3xl border border-white/60 bg-white/70 p-8 shadow-[0_30px_90px_-60px_rgba(15,23,42,0.5)] backdrop-blur-xl sm:p-10">
          <div className="flex flex-wrap items-center gap-3">
            <span className="rounded-full bg-[#1c1b17] px-3 py-1 text-xs font-semibold uppercase tracking-[0.2em] text-[#f6f1e8]">
              Hub oficial
            </span>
            <span className="rounded-full border border-[#1c1b17]/20 px-3 py-1 text-xs font-semibold uppercase tracking-[0.2em] text-[#1c1b17]/70">
              Linktree
            </span>
          </div>

          <div className="mt-8 space-y-4">
            <h1 className="linktree-serif text-4xl font-semibold leading-tight sm:text-5xl">
              Visao Alpha
            </h1>
            <p className="text-base text-[#3b372f] sm:text-lg">
              Conexoes imobiliarias com foco em dados, performance e proximidade.
            </p>
          </div>

          <div className="mt-10 space-y-4">
            <button
              type="button"
              className="linktree-stagger flex w-full items-center justify-between rounded-2xl border border-[#1c1b17]/10 bg-white/80 px-5 py-4 text-left text-base font-semibold text-[#1c1b17] shadow-[0_16px_40px_-30px_rgba(15,23,42,0.6)] transition hover:-translate-y-0.5 hover:border-[#1c1b17]/30 hover:bg-white"
              style={{ animationDelay: '0.08s' }}
            >
              <span className="flex items-center gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-emerald-500/15 text-emerald-800">
                  <Sparkles size={18} />
                </span>
                Apresentacao
              </span>
              <ArrowUpRight size={18} className="text-[#1c1b17]/60" />
            </button>

            <a
              className="linktree-stagger flex w-full items-center justify-between rounded-2xl border border-[#1c1b17]/10 bg-white/80 px-5 py-4 text-left text-base font-semibold text-[#1c1b17] shadow-[0_16px_40px_-30px_rgba(15,23,42,0.6)] transition hover:-translate-y-0.5 hover:border-[#1c1b17]/30 hover:bg-white"
              href="https://www.instagram.com/novavisaoalpha/"
              target="_blank"
              rel="noreferrer"
              style={{ animationDelay: '0.18s' }}
            >
              <span className="flex items-center gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-[#f58529]/15 text-[#f58529]">
                  <Instagram size={18} />
                </span>
                Instagram
              </span>
              <ArrowUpRight size={18} className="text-[#1c1b17]/60" />
            </a>

            <a
              className="linktree-stagger flex w-full items-center justify-between rounded-2xl border border-[#1c1b17]/10 bg-white/80 px-5 py-4 text-left text-base font-semibold text-[#1c1b17] shadow-[0_16px_40px_-30px_rgba(15,23,42,0.6)] transition hover:-translate-y-0.5 hover:border-[#1c1b17]/30 hover:bg-white"
              href="https://www.linkedin.com/company/vis%C3%A3o-alpha-neg%C3%B3cios-imobili%C3%A1rios/"
              target="_blank"
              rel="noreferrer"
              style={{ animationDelay: '0.28s' }}
            >
              <span className="flex items-center gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-sky-500/15 text-sky-700">
                  <Linkedin size={18} />
                </span>
                LinkedIn
              </span>
              <ArrowUpRight size={18} className="text-[#1c1b17]/60" />
            </a>
          </div>

          <div className="mt-10 flex flex-wrap items-center justify-between gap-4 text-xs uppercase tracking-[0.2em] text-[#1c1b17]/50">
            <span>Visao Alpha</span>
            <span>Imobiliario com metodo</span>
          </div>
        </div>
      </div>
    </div>
  );
};
